<div class="container">
    <div class="success-container" *ngIf="callbackData">
        <p class="order-number">
            <span>{{ "orderSuccess.orderId" | translate }}: </span>{{ callbackData!.orderid || orderId }}
        </p>
        <div class="inside-success-container">
            <mat-icon svgIcon="checkMark" class="check-mark" aria-hidden="false" aria-label="Check Mark"></mat-icon>
            <br />
            <h1>{{ "orderSuccess.orderConfirmed" | translate }}</h1>
            <br />
            <p>{{ "orderSuccess.orderSuccessMessage" | translate }}</p>
            <p>{{ "orderSuccess.orderDeliveryMessage" | translate }}</p>
            <br />
            <app-button variant="white" buttonClass="shadow-btn hover-bounce" (onClick)="onTrackOrder()">
                {{ "orderSuccess.button.trackMyOrder" | translate }}
            </app-button>
            <br />

            <app-button variant="hero" buttonClass="explore-btn" size="lg" (onClick)="onContinueShopping()">
                {{ "orderSuccess.button.continueShopping" | translate }}
            </app-button>
        </div>
    </div>
</div>
